import React from "react";
import { Formik, ErrorMessage, Form } from "formik";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { FormControl, Image } from "react-bootstrap";
import carImage from "../../images/car.png";

const styles = (theme) => ({
  center: {
    textAlign: "center",
  },
  bold: {
    fontWeight: "bold",
  },
  red: {
    color: "red",
  },
  grey: {
    color: "grey",
  },
  right: {
    textAlign: "right",
  },
  a: {
    textDecoration: "none",
    color: "blue",
  },
});

class LoginForm extends React.Component {
  validateEmail = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  };

  validatePassword = (value) => {
    let error;
    if (value === "") {
      error = "empty field";
    } else if (!/^(?=.*[A-Za-z])[A-Za-z\d$@!%*#?&.-]{8,}$/.test(value)) {
      error =
        "invalid password! Password should contain 8-20 characters [a-Z,!,@,#,$,%] and should contain numbers.";
    } else if (value.length > 20) {
      error = "password should not exceed 20 characters";
    }
    return error;
  };

  render() {
    const { loginUser, isLargeScreen, isMediumScreen } = this.props;

    return (
      <Box
        display="flex"
        width="100%"
        flexDirection={["column", "column", "column", "row"]}
        alignItems="center"
      >
        <Box
          width={["100%", "80%", "80%", "60%"]}
          display={isMediumScreen ? "none" : "block"}
          mt={[0, 0, 0, 20]}
        >
          <Box style={{ display: isLargeScreen ? "none" : "flex" }}>
            <Image src={carImage} alt="Car Image" width="100%" />
          </Box>
        </Box>
        <Box
          width={["100%", "80%", "80%", "60%"]}
          display={["block", "flex"]}
          height={["auto", "auto", "auto", "540px"]}
          p="12px 20px"
          justifyContent={["center"]}
          alignItems="center"
        >
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validate={(values) => {
              let errors = {
                email: this.validateEmail(values.email),
                password: this.validatePassword(values.password),
              };

              Object.keys(errors).forEach((key) => {
                if (errors[key] === undefined) {
                  delete errors[key];
                }
              });
              return errors;
            }}
            onSubmit={(values) => {
              loginUser(values.email, values.password);
            }}
          >
            {({ values, handleChange, handleSubmit, handleBlur }) => (
              <Box width={["auto", "350px"]}>
                <Form
                  onSubmit={(...args) => {
                    return handleSubmit(...args);
                  }}
                >
                  <Box>
                    <Box
                      className="heading-text-font"
                      color="#000"
                      fontSize="20px"
                      fontWeight="700"
                      mb={2}
                    >
                      <span style={{ color: "#E00000" }}>Sign</span> In
                    </Box>
                  </Box>
                  <Box>
                    <FormControl
                      placeholder="Email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      name="email"
                      type="email"
                      variant="outlined"
                      fullWidth
                      margin="dense"
                    />
                    <ErrorMessage
                      name="email"
                      className="errorMsg"
                      component="div"
                    />
                  </Box>
                  <Box mt={2}>
                    <FormControl
                      placeholder="Password"
                      type="password"
                      onBlur={handleBlur}
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      variant="outlined"
                      fullWidth
                      margin="dense"
                    />
                    <ErrorMessage
                      name="password"
                      className="errorMsg"
                      component="div"
                    />
                  </Box>
                  <Box textAlign="right" mt={2}>
                      <Link to="/forgot_password">
                        <span className="underLineOnHover">
                          Forgot password?
                        </span>
                      </Link>
                  </Box>
                  <Box mt={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      type="submit"
                      style={{
                        backgroundColor: "#E00000",
                        color: "white",
                        textTransform: "capitalize",
                      }}
                      className="btnHover"
                    >
                      Sign In
                    </Button>
                  </Box>
                  <Box display="flex" mt={2} width="100%">
                    <Box color="black">Don't have an account? </Box>
                    <Link to="/registration">
                      <Box color="#E00000" pl={1} className="underLineOnHover">
                        Sign up
                      </Box>
                    </Link>
                  </Box>
                </Form>
              </Box>
            )}
          </Formik>
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles)(LoginForm);
